import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { produce } from 'immer';

import * as constants from './constants';
import { CertificateModalActions, CertificateModalStore } from './typings';

const initialState: CertificateModalStore = {
    localities: [],
    statusOfGetLocalities: LOADING_STATUSES.UNSENT,
    statusOfAcceptSuggestion: LOADING_STATUSES.UNSENT,
    shownSuggestions: [],
    statusOfCertificateSection: LOADING_STATUSES.SUCCESS,
};

export const certificateModalReducer = (
    state: CertificateModalStore = initialState,
    action: CertificateModalActions
) => {
    // eslint-disable-next-line complexity, consistent-return
    return produce(state, (draft) => {
        switch (action.type) {
            case constants.GET_LOCALITIES_REQUEST:
                Object.assign(draft, {
                    statusOfGetLocalities: LOADING_STATUSES.LOADING,
                });
                break;

            case constants.GET_LOCALITIES_SUCCESS:
                Object.assign(draft, {
                    localities: action.localities,
                    statusOfGetLocalities: LOADING_STATUSES.SUCCESS,
                });
                break;

            case constants.GET_LOCALITIES_ERROR:
                Object.assign(draft, {
                    localities: [],
                    statusOfGetLocalities: LOADING_STATUSES.ERROR,
                });
                break;

            case constants.ACCEPT_SUGGESTION_REQUEST:
                draft.statusOfAcceptSuggestion = LOADING_STATUSES.LOADING;
                break;

            case constants.ACCEPT_SUGGESTION_SUCCESS:
                return updateShownSuggestionsAndReset(state, action.certificateSlug);

            case constants.ACCEPT_SUGGESTION_ERROR:
                draft.statusOfAcceptSuggestion = LOADING_STATUSES.ERROR;
                break;

            case constants.CLOSE_SUGGESTION:
                return updateShownSuggestionsAndReset(state, action.certificateSlug);

            case constants.CANCEL_SUGGESTION:
                return updateShownSuggestionsAndReset(state, action.certificateSlug);

            case constants.SET_CERTIFICATES_SECTION_REQUEST:
                draft.statusOfCertificateSection = LOADING_STATUSES.LOADING;
                break;

            case constants.SET_CERTIFICATES_SECTION_SUCCESS:
                draft.statusOfCertificateSection = LOADING_STATUSES.SUCCESS;
                break;

            case constants.SET_CERTIFICATES_SECTION_ERROR:
                draft.statusOfCertificateSection = LOADING_STATUSES.ERROR;
                break;

            // no default
        }
    });
};

function updateShownSuggestionsAndReset(state: CertificateModalStore, certificateSlug: string) {
    return { ...initialState, shownSuggestions: [...state.shownSuggestions, certificateSlug] };
}
